import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { getAerolines, addAeroline, removeAeroline, editAeroline } from './thunks'
import { COLUMN_NAMES } from '../../util/constants'


const initialState = {
  aerolines: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const aerolineSlice = createSlice({
  name: 'aerolines',
  initialState,
  reducers: {
    resetAerolineStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {

    builder.addCase(getAerolines.pending, (state, action) => {
      state.status = 'loading'
    })

    builder.addCase(getAerolines.fulfilled, (state, action) => {
      state.aerolines = action.payload || []
      state.status = 'successful'
      state.lastFetched = Date.now()
    })

    builder.addCase(getAerolines.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })

    builder.addCase(addAeroline.fulfilled, (state, action) => {
      state.aerolines.push(action.payload)
    })

    builder.addCase(removeAeroline.fulfilled, (state, action) => {
      state.aerolines = state.aerolines.filter(e => e.id !== action.payload)
    })

    builder.addCase(editAeroline.fulfilled, (state, action) => {
      const payload = action.payload
      if (payload && payload.id) {
        state.aerolines = state.aerolines.map(e => e.id === payload.id ? payload : e)
      }
    })


  }
})

export const aerolinesFormattedSelector = (state) => state.aeroline.aerolines

export const aerolineOptionsSelector = createDraftSafeSelector(
  aerolinesFormattedSelector,
  (state) => state.map(element => ({ label: element.name, value: element.id, logo_url: element.logo_url })),
)

export const aerolineToAssign = createDraftSafeSelector(
  aerolinesFormattedSelector,
  (state) => state.map(element => ({ name: element.name, id: element.id, logo_url: element.logo_url, column: COLUMN_NAMES.VALUES_TO_ASSIGN })),
)


export const { resetAerolineStatus } = aerolineSlice.actions;

export default aerolineSlice.reducer